import { render, staticRenderFns } from "./FavoriteEmailFilter.vue?vue&type=template&id=6b78d6e6&"
import script from "./FavoriteEmailFilter.vue?vue&type=script&lang=js&"
export * from "./FavoriteEmailFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports